<div class="timeline-container" *ngIf="events.length > 0">
    <div class="timeline">
        <!-- Timeline line with colored segments -->
        <div class="timeline-line">
            <div
                *ngFor="let segment of segments"
                class="timeline-segment"
                [class.timeline-segment-dotted]="segment.isDotted"
                [style.left.%]="segment.start"
                [style.width.%]="segment.end - segment.start"
                [style.background-color]="segment.color"
            ></div>
        </div>

        <!-- Timeline events -->
        <div
            *ngFor="let event of events; let i = index"
            class="timeline-event"
            [class.timeline-event-now]="event.isNow"
            [class.label-below]="!event.labelAbove"
            [style.left.%]="event.position"
        >
            <div class="timeline-point" [style.background-color]="event.color"></div>
            <div class="timeline-label">
                <div class="timeline-label-title">{{ event.label }}</div>
                <div class="timeline-label-date">{{ event.dateString }}</div>
            </div>
        </div>
    </div>
</div>
